
import { platform } from '@helpers/Constants';
import { getIOSVersion, getAndroidVersion } from '@helpers/Common';
import userStore from '@stores/user';
import axios, { AxiosResponse } from 'axios';
import { IApiSourceParams, IApiSourceResponse } from '@apis/client';
import { isCubeApp } from '@helpers/Constants';

// import axios, { AxiosResponse } from 'axios';

let reportInfo = {};

// function mount(info: {}) {
//   reportInfo = info;
// }

//操作系统
let operatingSystem = navigator.userAgent;
if(platform.android) {
  operatingSystem = 'Android ' + getAndroidVersion();
} else if(platform.ios) {
  operatingSystem = 'IOS ' + getIOSVersion();
}

interface Response<T> {
  data: T;
  message: string;
  statusCode: number;
}

const addEvent = async(code: string, extraData?: {}) => {
  const environment  = isCubeApp() ? 'app' : 'h5'
  const params = {
    $cp: {
      platformType: 'mobile',
      os: operatingSystem,
    },
    $sp: [
      {
        environment,
        $code: 'app_' + code,
        $ts: Date.now(),
        $tid: userStore.userInfo.uid,
        ...extraData,
        ...reportInfo,
      },
    ],
  };
  await axios
    .post<
        IApiSourceParams,
        AxiosResponse<Response<IApiSourceResponse>>
    >(`${window.PUBLIC_URL}/report`, params, {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
    .catch(e => {
      throw new Error('ERROR_REPORT_REQUEST');
    });
}

export default {
  addEvent,
  // mount,
};
